import {Component, OnInit, Input, Output, EventEmitter, NgModule, OnChanges, ViewChild} from '@angular/core';
import {TreeNode,TreeModule,ContextMenuModule} from 'primeng/primeng';

import {UserGroup} from '../model/usergroup';
import {GuideService} from "../service/guide_service.component"
import {Tree} from "primeng/components/tree/tree";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS

@Component({
    selector:'ex-userchecktree',
    templateUrl:'./user_checktree.component.html'
})
export class UserGroupCheckTreeComponent implements OnInit,OnChanges{
    private user_group:UserGroup[];

    private selected_group:UserGroup;
    selectedGroups : TreeNode[] = [];
    @Input() setTargetGroupList : any[];
    @Input() company : any;
    @Output() onSelect:EventEmitter<any> = new EventEmitter();

    @ViewChild('tree') tree : Tree;
    constructor(private service:GuideService, private logger : Logger) {

    }
    ngOnInit() {

    }

    ngOnChanges(){
      //this.logger.debug("바꾸니 부분 setTargetGroupList" , this.setTargetGroupList);
      this.loadAttributeGroupByCompany();

    }
    onNodeSelects(event:any):void{
      this.onSelect.emit(this.selectedGroups);
    }
    onNodeUnSelect(event:any):void{
      this.onSelect.emit(this.selectedGroups);
    }

    // TreeNode 셀렉션 처리
    createRootSelection(PolicyTreeItem,targetList){
      if(targetList && targetList.length > 0) {
        targetList.forEach(target => {
          if(PolicyTreeItem.name == target.name) {
            this.selectedGroups.push(PolicyTreeItem);
            this.createChildSelection(PolicyTreeItem);
          }
        })
      }
     /* this.logger.debug("select group :", this.selectedGroups);
      this.logger.debug("===================================================================")*/
    }

    createChildSelection(PolicyTreeItem) {
      this.findEqual(PolicyTreeItem);
      if(PolicyTreeItem.children && PolicyTreeItem.children.length > 0){

        PolicyTreeItem.children.forEach(pItem => {
            this.createChildSelection(pItem);
        })
      }
    }

    findEqual(item){
      if(this.setTargetGroupList && this.setTargetGroupList.length > 0){

        this.setTargetGroupList.forEach(tem => {
          if(tem.label ==  item.label){
            this.selectedGroups.push(item);
          }
        })
      }
    }

    /*private loadUserGroup():void{
        var url_path = "/mgr/system/attribute/group";
        this.logger.debug("loadUserGroup : " + url_path);
        this.service.get(url_path,null,null).subscribe(
            value => {
                this.logger.debug("loadUserGroup : ", value);
                this.user_group = value;

                this.selectedGroups = [];
                value.forEach(item => {
                  this.createChildSelection(item);
                })

               /!* this.logger.debug("여기는 setTagetGroupList ", this.setTargetGroupList);
                this.logger.debug("what > : ",this.selectedGroups);*!/
                this.onSelect.emit(this.selectedGroups);
            },
            error=>{ this.logger.error("-- error : " + error); },
            ()=>{ this.logger.info("-- complate : "); }
        )
    }*/
    private loadAttributeGroupByCompany():void{
        if(this.company){

          this.logger.debug("company",this.company);
          var url_path = "/mgr/system/attribute/group/"+this.company.id;
          this.logger.debug("loadUserGroup : " + url_path);
          this.service.get(url_path,null,null).subscribe(
            value => {
              this.logger.debug("loadUserGroup : ", value);
              this.user_group = value;

              this.selectedGroups = [];
              value.forEach(item => {
                this.createChildSelection(item);
              })

              /* this.logger.debug("여기는 setTagetGroupList ", this.setTargetGroupList);
               this.logger.debug("what > : ",this.selectedGroups);*/
              this.onSelect.emit(this.selectedGroups);
            },
            error=>{ this.logger.error("-- error : " + error); },
            ()=>{ this.logger.info("-- complate : "); }
          )
        }

    }

    /*private loadAttributeGroupByCompany2(company:any):void{
      this.logger.debug("--company changed : ", company);
      var url_path = "/mgr/system/attribute/group/" +comapny.id;
      this.service.get(url_path,null,null).subscribe(
        value => {
          this.logger.debug("loadUserGroup : ", value);
          this.group_list = value;
        },error=>{this.logger.error("-- error : " + error); }
        ,()=>{
          this.logger.info("-- complate : ");
        }
      )
    }*/

}

@NgModule({
    imports:[TreeModule,ContextMenuModule],
    declarations:[UserGroupCheckTreeComponent],
    exports:[UserGroupCheckTreeComponent],
    providers:[GuideService]
})
export class UserGroupCheckTreeModule{
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/user_checktree.component.ts